export const PDF_FILE_TYPE = 'PDF';
export const RTF_FILE_TYPE = 'RTF';
export const EXCEL_FILE_TYPE = 'EXCEL';

export const ESG_STANDARD_REPORT_TYPE = 'ESG_STANDARD';
export const ESG_DD_REPORT_TYPE = 'ESG_DD';
export const ESG_GREEN_BUILDING_REPORT_TYPE = 'ESG_GREEN_BUILDING';
export const ESG_GREEN_BUILDING_SHORT_REPORT_TYPE = 'ESG_GREEN_BUILDING_SHORT';
export const PAST_REPORT_TYPE = 'PAST';
